import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import ImageV2 from 'components_v2/common/ImageV2';

class Banner extends React.PureComponent {
  render() {
    const { imageUrl, link, gaData, altTag, wrapperClassName } = this.props;
    if (imageUrl && link) {
      return (
        <Link
          to={link}
          className={wrapperClassName || ''}
          data-ga={gaData || ''}
          target={this.props.target || ''}
        >
          <ImageV2 src={imageUrl} alt={altTag || ''} />
        </Link>
      );
    } else if (imageUrl) {
      return (
        <span>
          <ImageV2 src={imageUrl} alt={altTag || ''} />
        </span>
      );
    }

    return null;
  }
}

Banner.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  gaData: PropTypes.string,
  altTag: PropTypes.string,
  wrapperClassName: PropTypes.string,
};

Banner.defaultProps = {
  gaData: '',
  altTag: '',
  wrapperClassName: '',
};

export default Banner;
